import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OrganizeService } from '../../../../../../common/services/Organize.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SocketService } from '../../../../../../common/services/Socket.service';
import { OrganizationConst } from './organization.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import * as _ from 'lodash';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.css'],
  providers: [BsModalService, OrganizeService],
})
export class OrganizationComponent extends BaseListComponent {
  @ViewChild('templateOrganize') templateOrganize: ElementRef;

  public list: any = [];
  public total = 0;
  public modelFilter: any = {};

  public modalRef2: any;
  public id_delete: any;
  public limited: number;
  public is_load_data = false;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private organizeService: OrganizeService,
    private socketService: SocketService
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = OrganizationConst.displayColumns();
  }

  ngOnInit() {
    this.loadData();
  }

  async loadData(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.organizeService.list(payload).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.data = res.data.list;
        this.initPage(res.data.total);
      }
    });
  }

  openOrganize(organize) {
    this.socketService.opentab(organize, 'organize', 'edit');
  }

  async addOrganize() {
    this.organizeService.create(this.model).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.loadData();
          this.closeModal();
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async search() {
    this.currentPage = 1;
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      await this.loadData({ name: this.modelFilter.keyword.trim() });
    } else {
      await this.loadData();
    }
  }

  async openConfirmDelete(id) {
    this.id_delete = id;
    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      this.organizeService._delete(this.id_delete).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.throwSuccess('Xóa thành công!');
            this.loadData();
          } else {
            this.throwError(res.message);
          }
        },
        error => {
          this.throwError(error.message);
        }
      );
    }
  }

  async setUpModel() {
    this.typeModal = 'add';
    this.modelContent = {
      type: ModalType.Primary,
      title: this.typeModal === 'add' ? 'Thêm mới tổ chức' : 'Cập nhật tổ chức',
      submit_title: this.typeModal === 'add' ? 'Thêm mới' : 'Cập nhật',
    };
    this.modelDisplay = [
      {
        key: 'name',
        label: 'Tên tổ chức',
        type: FormFieldType.Text,
        value: this.model.name,
        required: true,
        disabled: false,
        width: 'full',
        order: 0,
      },
      {
        key: 'domain',
        label: 'Domain',
        type: FormFieldType.Text,
        value: this.model.domain,
        required: false,
        disabled: false,
        width: 'full',
        order: 1,
      },
    ];
  }

  async handleAction(type: any, item?: any) {
    this.model = {};
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      class: 'modal-md',
      keyboard: false,
    };
    switch (type) {
      case TableAction.add:
        await this.setUpModel();
        this.openModal(this.templateOrganize, config, null, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.edit:
        this.openOrganize(item);
        break;
      case TableAction.delete:
        this.openConfirmDelete(item.organize_id);
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    await this.addOrganize();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/expert/organization/organization.component.ts